const SUGGESTIONS_REGEX = /\{\{suggestions:(\[.*?\])\}\}/g;

/**
 * Extract suggestion chips from message content.
 * Strips the {{suggestions:[...]}} marker and parses the JSON array.
 * Gracefully handles malformed JSON (returns empty suggestions, keeps marker in content).
 */
export function extractSuggestions(content: string): {
  cleanedContent: string;
  suggestions: string[];
} {
  const suggestions: string[] = [];
  let cleanedContent = content;

  SUGGESTIONS_REGEX.lastIndex = 0;
  const match = SUGGESTIONS_REGEX.exec(content);

  if (match) {
    try {
      const parsed = JSON.parse(match[1]);
      if (Array.isArray(parsed)) {
        suggestions.push(...parsed.filter((s): s is string => typeof s === 'string'));
      }
      cleanedContent = content.slice(0, match.index) + content.slice(match.index + match[0].length);
      cleanedContent = cleanedContent.trimEnd();
    } catch {
      // Malformed JSON — leave marker in content, return no suggestions
    }
  }

  return { cleanedContent, suggestions };
}
